import { getDemoData, matchRestRequest } from '../utils'

export const mockGetOvertimeReviewShifts = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/shifts_to_review_needs_attention_9c817ffd',
      'POST'
    ),
  getResponse: async () => {
    const demoData = getDemoData()

    return {
      data: {
        company: {
          overtimeReviewShifts: demoData.shifts.filter((shift) =>
            (shift.work || []).some((work) => work.status === 'employer_review')
          ),
        },
      },
    }
  },
}

export const mockGetPendingReviewShifts = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/shifts_to_review_needs_attention_141ba64d',
      'POST'
    ),
  getResponse: async () => {
    const demoData = getDemoData()

    return {
      data: {
        company: {
          overtimeReviewShifts: demoData.shifts.filter((shift) =>
            (shift.work || []).some(
              (work) =>
                work.status &&
                ['completed', 'admin_review'].includes(work.status)
            )
          ),
        },
      },
    }
  },
}

export const mockGetPendingTryoutReviewShifts = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/shifts_to_review_tryouts_5f29674b',
      'POST'
    ),
  getResponse: async () => {
    return {
      data: {
        company: {
          tryoutReviewShifts: [],
        },
      },
    }
  },
}
